import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import { Minimal as MinimalLayout } from './layouts';
import { DynamicLoader, RouteWithLayout } from "components";
import { SignIn } from "views";
import AuthenticationList from "views/AuthenticationList";
import AuthenticationSearch from "views/AuthorizationSearch";

const routeSchema = [
  {
    component: SignIn,
    path: "/sign-in",
    layout: MinimalLayout
  },
  {
    component : AuthenticationList,
    path : "/authentication-list"
  },
  {
    component : AuthenticationSearch,
    path : "/authentication-search"
  },
  {
    component: DynamicLoader(() => import("views/NotFound")),
    path: "/not-found",
  },
];

export const Routes = (props) => {
  const { index = "/dashboard" } = props;
  return (
    <Switch>
      <Redirect exact from="/" to={index} />
        {routeSchema.map((value, index) => {
          const { component, exact = true, path, layout} = value;
          return <RouteWithLayout key={index} component={component} exact={exact} layout={layout} path={path} />;
        })}
      <Redirect to="/not-found" />
    </Switch>
  );
};
